module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wrappers/has-error.html
 ** module id = 18
 ** module chunks = 0
 **/